import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { useCallback } from 'react';
import { useQuoteListState } from 'shared/contexts/quotes-summary-context';
import { useDeleteQuote, useGetQuote } from 'shared/mutations/quotes';
import { QuoteDocument } from 'shared/types/quotes';

export function DeleteDialog() {
  const { quoteIdToDelete, setQuoteIdToDelete, deleteDialogOpen, toggleDeleteDialog } = useQuoteListState();
  const { data } = useGetQuote(quoteIdToDelete);
  const deleteQuoteMutation = useDeleteQuote();

  const onClose = useCallback(() => {
    setQuoteIdToDelete('');
    toggleDeleteDialog();
  }, [setQuoteIdToDelete, toggleDeleteDialog]);

  const onDelete = useCallback(async () => {
    const quote: QuoteDocument = {
      ...data!,
      dateDeleted: new Date().toISOString(),
    };
    data && (await deleteQuoteMutation.mutateAsync(quote));
    toggleDeleteDialog();
    setQuoteIdToDelete('');
  }, [data, deleteQuoteMutation, toggleDeleteDialog, setQuoteIdToDelete]);

  return (
    <Dialog open={deleteDialogOpen} onClose={onClose} fullWidth={true} aria-labelledby='delete-dialog'>
      <DialogTitle id='delete-dialog-title'>Are you sure you want to delete this quote?</DialogTitle>
      <DialogActions>
        <Button onClick={onClose} color='primary'>
          No
        </Button>
        <Button onClick={onDelete} color='primary'>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
